export const serverKeys = {
	options: ["servers", "options"],
};
